import { createFileRoute } from '@tanstack/react-router';
import { DocsPage } from '@/features/metric-hub/docs/DocsPage';
import { useDocsReadingTracker } from '@/features/metric-hub/docs/use-docs-reading-tracker';
import { useTrackSkillOnDwell } from '@/features/metric-hub/onboarding/use-skill-tracker';

function DocsRoute() {
  // Docs is a deep page — 30s dwell so the skill marks "they actually read it".
  useTrackSkillOnDwell('read_docs', 30_000);
  // Training-certificate gate: scroll-to-end + cumulative active time.
  useDocsReadingTracker();
  return <DocsPage />;
}

export const Route = createFileRoute('/_authed/metric-hub/docs')({
  component: DocsRoute,
});
